import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { SnackbarService } from "../error/snackbar.service";
import { catchError, Observable } from "rxjs";
import { EntraIdUserModel } from "../../models/users/entra-id-user.model";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { FoMaUserModel } from "../../../views/users-view/models/foma-user.model";
import { browserOnly } from "./browser-only.util";

@Injectable({
    providedIn: 'root'
})
export class UserApiService {
    private apiUrl = environment.apiBaseUrl;
    errorResponse: string = "";

    constructor(
        private http: HttpClient,
        private snackBarService: SnackbarService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
    }

    getAllProductionLeadersList(): Observable<EntraIdUserModel[]> {
        return browserOnly<EntraIdUserModel[]>(this.platformId, [], () => this.http.get<EntraIdUserModel[]>(`${this.apiUrl}/production-leaders`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
    }

    getFoMaUsersList(): Observable<FoMaUserModel[]> {
        return browserOnly<FoMaUserModel[]>(this.platformId, [], () => this.http.get<FoMaUserModel[]>(`${this.apiUrl}/users`).pipe(catchError(error => this.snackBarService.handleApiError(error))));
    }
}